import { BrowserRouter, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "keen-slider/keen-slider.min.css";
import "./App.scss";
import Router from "./Router";
import { constants } from "./utility/constants/constants";
import { useGoogleAnalytics } from "./utility/hooks/useGoogleAnalytics";
import { useGTM } from "./utility/hooks/useGTM";
import { usePerformanceTracking } from "./utility/hooks/usePerformanceTracking";

function AppContent() {
  const location = useLocation();
  const isGAInitialized = useGoogleAnalytics();

  useGTM();

  usePerformanceTracking(location.pathname, isGAInitialized);

  return (
    <>
      <Router />
      <Toaster position={"top-right"} toastOptions={{ className: "react-hot-toast" }} />
      {constants.ENV === "development" && <p className="dev-env">Testing Environment</p>}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
